export class LoginPrecheckForm {
    $email = $('#Email');
    init() {
        this.$email.on('input', () => this.disablingNextButton());
        this.disablingNextButton();
    }

    disablingNextButton(){
        if (this.$email.val().toString().length===0) {
            $(".btn-next").attr('disabled', 'disabled');
        } else {
            $(".btn-next").removeAttr('disabled');
        }
    }
}
